var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "StorefrontViews",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-storefront-views","viewBox":"0 0 100 100"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M31.4 51.654h-2.749a1.64 1.64 0 0 1-1.65-1.632V39.517c0-.062.004-.124.011-.184-.034-.27.001-.556.12-.834l4.495-10.503a1.65 1.65 0 0 1 1.52-.996h33.707a1.65 1.65 0 0 1 1.519.996l4.495 10.503a1.6 1.6 0 0 1 .12.834c.007.06.01.122.01.184v10.505a1.64 1.64 0 0 1-1.65 1.632H68.41v19.715A1.64 1.64 0 0 1 66.759 73H33.051a1.64 1.64 0 0 1-1.65-1.631V51.654zm20.897 18.083H65.11V51.992H52.297v17.745zm-3.3 0V51.992H34.7v17.745h14.297zM50 100C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50zm0-4c25.405 0 46-20.595 46-46S75.405 4 50 4 4 24.595 4 50s20.595 46 46 46zm15.76-65.737H34.24l-3.1 7.24h37.72l-3.1-7.24zM69.7 48.39v-7.24H30.3v7.242h39.4z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/storefront-views.svg